var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scliente-page-pad"},[_c('cliente-financeiro-list',{staticClass:"m-t fin-cliente",attrs:{"cliente":_vm.cliente}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }